import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Table,
} from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Routes } from "../../routes";
import { authFetch } from "../../auth";
import queryString from "query-string";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { MatNotAllowed, MatProccessModal } from "../../components/Modal";

export function setSearchResult(result) {
  console.log("setSearchResult");
  /*
  const [list, setList] = useState([]);
  list.forEach((item) => {
    console.log(item);
  });

  useEffect(() => {
    fetch("/api/company", {
      method: "get",
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp) {
          setList(resp);
        }
      });
  }, []);

  return (
    <Container fluid className="my-2">
      <Row xs={1} md={2} lg={4} className="g-4 justify-content-center">
        {list.length &&
          list.map((item) => <HomeDisplayItem item={item} key={item._index} />)}
      </Row>
    </Container>
  );
*/
}

const AttentionDisplayItem = ({ item }) => {

  if(item.content == undefined)
    item.content = "Some quick example text to build on the card title and make up the bulk of the card's content."

  if(item.logo_path == undefined)
    item.logo_path = "profile-cover.jpg"

  console.log(item.logo_path);

  var index = "company" + item.RegistrationID

  return (
    <Card className="mx-2 mb-4 pt-2" style={{ flexBasis: "22%" }}>
      <Card.Img variant="top" src={item.logo_path} />
      <Card.Body>
        <Card.Title
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          }}
        >
          {item.Name}
        </Card.Title>
        <Button
          variant="outline-primary"
          href={
            Routes.CompInfo.path + "?index=" + index + "&id=" + item.id + ".0"
          }
        >
          <FormattedMessage id="more" />
        </Button>
      </Card.Body>
    </Card>
  );
};

const CompanyItem = ({ item, handler, idx }) => {
  return (
    <tr>
      <td>
        <input
          id=""
          type="checkbox"
          onChange={(e) => handler(e, item.RegistrationID)}
        />
      </td>
      <td>{idx + 1}</td>
      <td>
        {item.country === 2 ? (
          <FormattedMessage id="Russia" />
        ) : (
          <FormattedMessage id="Korea" />
        )}
      </td>
      <td>
        <Link
          to={
            Routes.CompInfo.path +
            "?index=company" +
            item.RegistrationID +
            "&id=" +
            item.id + ".0"
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "underline",
          }}
        >
          {item.Name}
        </Link>
      </td>
      <td>{item.industry}</td>
    </tr>
  );
};

const CompanyTable = ({ companyList, handler }) => {
  return (
    <Table responsive hover>
      <thead>
        <tr>
          <th>#</th>
          <th>번호</th>
          <th>
            <FormattedMessage id="country" />
          </th>
          <th>
            <FormattedMessage id="companyNm" />
          </th>
          <th>
            <FormattedMessage id="business" />
          </th>
        </tr>
      </thead>
      <tbody>
        {companyList.map((item, idx) => (
          <CompanyItem item={item} idx={idx} handler={handler} key={item.id} />
        ))}
      </tbody>
    </Table>
  );
};

export default (props) => {
  const location = useLocation();
  const query = queryString.parse(location.search);
  const [checkedItems, setCheckedItems] = useState(new Set());
  const [control, setControl] = useState({
    show: false,
    msgId: "",
    disabled: false,
  });
  const { show, msgId, disabled } = control;

  const [list, setList] = useState([]);
  list.forEach((item) => {
    //console.log(item);
  });

  const checkedItemHandler = (id, isChecked) => {
    console.log(id);
    console.log(isChecked);

    if (isChecked) {
      checkedItems.add(id);
      setCheckedItems(checkedItems);
    } else if (!isChecked && checkedItems.has(id)) {
      checkedItems.delete(id);
      setCheckedItems(checkedItems);
    }
  };

  const [bChecked, setChecked] = useState(false);

  const checkHandler = ({ target }, id) => {
    setChecked(!bChecked);
    checkedItemHandler(id, target.checked);
  };

  useEffect(() => {
    authFetch(process.env.REACT_APP_API_URL + "/api/attention", {
      method: "post",
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp) {
          console.log(resp.json_list);
          setList(resp.json_list);
        }
      });
  }, []);

  const onMatchingReq = () => {
    var Request_list = [];

    if (checkedItems.size === 0) return;

    setControl({ disable: true, show: true, msgId: "" });

    checkedItems.forEach((item) => {
      Request_list.push(item);
    });

    authFetch(process.env.REACT_APP_API_URL + "/api/matchingReq", {
      method: "post",
      body: JSON.stringify({
        requestList: Request_list,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        setControl((prev) => ({ ...prev, diabled: false }));
      } else if (resp.status === 201) {
        setControl((prev) => ({
          ...prev,
          diable: false,
          msgId: "matchingAddedDup",
        }));
      } else if (resp.status === 401) {
        setControl((prev) => ({
          ...prev,
          disabled: false,
          msgId: "matNotAllowed",
        }));
      } else {
        console.log(resp);
      }
    });
  };

  const onDeleteReq = () => {
    var Request_list = [];

    if (checkedItems.size === 0) return;

    checkedItems.forEach((item) => {
      //console.log(item);
      Request_list.push(item);
    });
    authFetch(process.env.REACT_APP_API_URL + "/api/del-attention", {
      method: "delete",
      body: JSON.stringify({
        requestList: Request_list,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        //setRegAtt(true);
        console.log(resp);
        window.location.reload();
      } else {
        console.log(resp);
      }
    });
  };

  return (
    <Container fluid className="pl-5" style={{ minHeight: "615px" }}>
      <div style={{ width: "90%" }}>
        <Row>
          {list.length > 0 ? (
            list.map((item) => (
              <AttentionDisplayItem item={item} key={item._index} />
            ))
          ) : (
            <div>
              <FormattedMessage id="noResult" />
            </div>
          )}
        </Row>
      </div>
    </Container>
  );
};

// 매칭 확인 메세지
// 매칭
